interface CreateTreeBarProps {
  point: [number, number] | null;
  quadraLabel: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

function formatCoord(value: number): string {
  return value.toFixed(7).replace(".", ",");
}

/**
 * Fluxo B do plano multicanal (§5): CREATE_TREE_MODE.
 *
 * O console resolve a parte espacial — que e a sua forca — e entrega a
 * coordenada ao FIQ-1, em vez de duplicar o formulario de cadastro aqui.
 * Assim a checagem de duplicidade, a derivacao territorial e a geracao do
 * codigo continuam existindo em um unico lugar.
 */
export default function CreateTreeBar({
  point,
  quadraLabel,
  onConfirm,
  onCancel,
}: CreateTreeBarProps) {
  return (
    <div className="absolute left-1/2 -translate-x-1/2 bottom-4 z-[1000] w-[min(92%,640px)]">
      <div className="rounded-xl border border-primary-200 bg-white/95 backdrop-blur shadow-lg px-4 py-3">
        {point ? (
          <div className="flex items-center gap-3 flex-wrap">
            <i className="ri-plant-line text-primary-600 text-lg" />
            <div className="min-w-0 flex-1">
              <p className="text-sm text-foreground-900">
                Posição do tronco definida
                {quadraLabel && (
                  <span className="text-foreground-500"> — quadra {quadraLabel}</span>
                )}
              </p>
              <p className="text-[11px] font-mono text-foreground-500 mt-0.5">
                {formatCoord(point[1])} , {formatCoord(point[0])}
              </p>
              <p className="text-[11px] text-foreground-400 mt-0.5">
                Arraste o marcador ou clique de novo para reposicionar.
              </p>
            </div>
            <button
              onClick={onCancel}
              className="px-3 py-2 rounded-lg border border-background-200 text-sm text-foreground-700 hover:bg-background-50 cursor-pointer"
            >
              Cancelar
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-2 rounded-lg bg-primary-600 text-white text-sm font-medium hover:bg-primary-700 cursor-pointer"
            >
              Continuar para o cadastro
            </button>
          </div>
        ) : (
          <div className="flex items-center gap-3">
            <i className="ri-cursor-line text-primary-600 text-lg" />
            <p className="text-sm text-foreground-700 flex-1">
              Clique no local do tronco do exemplar arbóreo.
            </p>
            <button
              onClick={onCancel}
              className="px-3 py-2 rounded-lg border border-background-200 text-sm text-foreground-700 hover:bg-background-50 cursor-pointer"
            >
              Sair do modo
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
